import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "cross-large, crossed large, close" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M4.1665 4.66602L15.8332 16.3327M15.8332 4.66602L4.1665 16.3327",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }